import {endpoints as ep} from 'core/constants'
import {createPermissionRules} from 'utils/permissionRules'

export const normalizePermissions = (permissions = []) => {
  const permissionRules = permissions.reduce((acc, permission) => {
    const {resource, action} = permission
    let rule = createPermissionRules({resource, action}) || null
    if (rule) {
      return {...acc, [rule]: rule}
    }

    return acc
  }, {})

  return permissionRules
}

export const getPermissionsQuery = {
  query: () => ({url: ep.permissions.all}),
  transformResponse: response => {
    const permissions = [{"action":"create","resource":"PROMOTIONS"},{"action":"read","resource":"PROMOTIONS"}];
    return {
      permissions: normalizePermissions(permissions),
      workFlows: [],
    }
  },
}
